// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EtX3RmoBkPBJ2yb8qYre {\n  display: flex;\n}\n", "",{"version":3,"sources":["webpack://./src/components/common/AddressAutocompleteField/AddressAutocompleteField.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF","sourcesContent":[".suggestion {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"suggestion": "EtX3RmoBkPBJ2yb8qYre"
};
export default ___CSS_LOADER_EXPORT___;
